<template>

    <div class="w-full">

        <div class="p-4 bg-white border border-blue-700 rounded-lg">
            For current box locations, please reference this <a class="text-blue-600" href="https://docs.google.com/document/d/1s2H8aKIelnSssj2L98UdaUFsGQPJVU67w2UoRUl1FSE/edit?usp=sharing" target="_blank">Google Doc</a>.
        </div>
    
        <div class="w-full flex flex-wrap mt-4" v-if="userInfo.network !== 9">
            <div class="w-full md:w-full lg:w-1/2 xl:w-1/3 px-2 mb-2" v-for="device in deviceIds" :key="device.id">
                <div class="w-full flex justify-between items-center">
                    <h1 class="text-xl font-bold">{{ device.id }}</h1>
                </div>
                <SurgeRemotePlayer :id="device.id" :streamId="device.streamId" />
            </div>
        </div>

    </div>
			
</template>

<script>

    import { EventBus } from '../../utils/events';
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import moment from 'moment';
    import SurgeRemotePlayer from './components/SurgeRemotePlayer'
    import StreamUrl from './components/StreamUrl'
    import CustomTable from '@/components/general/CustomTable'

	export default {
		name: 'Chasers',
		data () {
			return {
                deviceIds: [
                    {
                        id: 'LT010',
                        streamId: 'XDd2AakVKyFwOpCoaFMk',
                        location: 'Holly Beach, LA',
                        locationUrl: 'https://www.google.com/maps?q=29.770835,-93.452627&shorturl=1'
                    },
                    {
                        id: 'LT030',
                        streamId: 'c6fAV7llBRKPKrfKbuCc',
                        location: 'Cameron, LA',
                        locationUrl: "https://www.google.com/maps/place/29%C2%B047'46.4%22N+93%C2%B019'19.1%22W/@29.7963891,-93.3236025,18.18z/data=!4m8!1m2!11m1!2sEEtoBFhoiRhTk_K2lMAXcRO-Ux7rcA!3m4!1s0x0:0x0!8m2!3d29.7962196!4d-93.3219725"
                    },
                    {
                        id: 'LT040',
                        streamId: 'ddV3XyW7ZNbpIcotVLML',
                        location: 'Hackberry, LA',
                        locationUrl: "https://www.google.com/maps/place/29%C2%B051'18.3%22N+89%C2%B040'42.5%22W/@29.8550833,-89.6806609,17z/data=!3m1!4b1!4m8!1m2!11m1!2sEEtoBFhoiRhTk_K2lMAXcRO-Ux7rcA!3m4!1s0x0:0x0!8m2!3d29.8550706!4d-89.6784702"
                    },
                    {
                        id: 'LT050',
                        streamId: 'O2KktddSLkxeuQCEgjeM',
                        location: 'Orange, TX.',
                        locationUrl: null
                    },
                    {
                        id: 'LT060',
                        streamId: 'OUWRzS0hVQ5V5xK2Szti',
                        location: 'Lake Charles, LA (Civic Center)',
                        locationUrl: "https://www.google.com/maps/place/30%C2%B013'47.9%22N+93%C2%B013'18.4%22W/@30.2296918,-93.2235014,17.47z/data=!4m8!1m2!11m1!2sEEtoBFhoiRhTk_K2lMAXcRO-Ux7rcA!3m4!1s0x0:0x0!8m2!3d30.2299741!4d-93.2217739"
                    },
                    {
                        id: 'LT070',
                        streamId: 'QSQy5ZTFfF4ZkiYt2oKq',
                        location: 'Westlake, LA',
                        locationUrl: null
                    },
                    {
                        id: 'J020',
                        streamId: 'kXwb7C0kD3jjSYA8wy2e',
                        location: 'River Road - Lake Charles, LA',
                        locationUrl: null
                    },
                    {
                        id: 'J010',
                        streamId: '6p5GUe4ZtvPH64gNmLBt',
                        location: 'River Road - Lake Charles, LA',
                        locationUrl: null
                    }
                ]
			}
        },
        components: {
            SurgeRemotePlayer,
            StreamUrl,
            CustomTable
        },
        computed: {
			...mapGetters([
                'userInfo',
            ]),
        },
        mounted() {
            console.log(this.userInfo)
        },
        methods: {
            ...mapGetters([
                'getAuthorizationHeader',
            ]),
            getChasers() {
                this.$http.get("https://api.livestormchasing.com/api/v1/chasers/cdn").then((response) => {
                    this.$set(this, 'chasers', response.data);
                    this.$set(this, 'polling', false);
                });
            },
            unlockStream(chaser) {
                this.unlocking = true

                var self = this;
                this.$http.post(Config.apiPath + "/api/v2/media/stream/unlock", {
                    streamId: chaser.stream_id,
                    chaser: chaser.user.name,
                }, this.getAuthorizationHeader())
                    .then((response) => {
                        self.unlocking = false
                        self.unlockedStreams.push(response.data)
                    })
            },
            getUnlockedStreams() {
                var self = this;
                this.$http.get(Config.apiPath + "/api/v2/media/stream/active", this.getAuthorizationHeader())
                    .then((response) => {
                        self.unlockedStreams = response.data
                    })
            },
            openStream(chaser) {
                var token = null
                window.open("https://cdn.livestormsvideo.com/media/stream/" + chaser.stream_id + "?token=" + this.getToken(chaser.stream_id) + "&name=" + chaser.user.name, '_blank', 'height=720,width=1280');
            },

            checkIfIsUnlocked(streamId) {
                return this.unlockedStreams.filter(stream => {
                    return stream.stream_id == streamId
                }).length > 0 ? true : false
            },

            getToken(streamId) {
               return this.unlockedStreams.filter(stream => {
                    return stream.stream_id == streamId
                })[0]['secure_id']
            }
        },
        filters: {
            displayDate: function(data) {
                return moment.utc(data).local().format('MM/DD/YY');
            },
            timeAgo: function(date) {
                return moment.utc(date).fromNow();
            },
        }
	}
</script>

<style scoped>
    .embed-responsive {
        position: relative;
        display: block;
        width: 100%;
        padding: 0;
        overflow: hidden;
    }

    .embed-responsive-16by9::before {
        padding-top: 56.25%;
    }

    .embed-responsive::before {
        display: block;
        content: "";
    }

    .embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border: 0;
    }
</style>
